import businessService from 'Services/BusinessService'
import merchantAccountGroupService from 'Services/MerchantAccountGroupService'

// initial state
const state = {
  merchants: []
}

// getters
const getters = {
  merchant: state => merchantId => state.merchants.find(merchant => merchant.merchantId === merchantId) || {},
  merchantCurrencies: (state, getters) => merchantId => getters.merchant(merchantId).currencies || [],
  merchantAccountGroups: (state, getters) => merchantId => getters.merchant(merchantId).accountGroups || []
}

const actions = {
  filterMerchants: ({ commit }, { context, filterContext }) => {
    return new Promise((resolve, reject) => {
      businessService.getMerchants(context, filterContext).then(result => {
        commit('setMerchants', result.data)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getMerchants: ({ dispatch }, context) => {
    return dispatch('filterMerchants', { context }).then(result => result.data)
  },

  getMerchant: ({ commit }, context) => {
    return new Promise((resolve, reject) => {
      businessService.getMerchant(context).then(result => {
        commit(state.merchants.some(item => item.merchantId === result.merchantId) ? 'updateMerchant' : 'setMerchant', result)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getMerchantAccountGroups: ({ commit }, context) => {
    const businessId = context?.business?.id || context?.businessId
    const merchantId = context?.merchant?.id || context?.merchantId

    if (!businessId || !merchantId) {
      return Promise.reject(new Error('Invalid parameters: businessId and merchantId are required'))
    }

    return new Promise((resolve, reject) => {
      merchantAccountGroupService.getAll(context).then(result => {
        commit('updateMerchant', { merchantId, accountGroups: result.accountGroups, grossSettlement: result.grossSettlement })
        resolve(result.accountGroups)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getMerchantAccount: ({ commit }, { businessId, merchantId, accountNumber }) => {
    return new Promise((resolve, reject) => {
      merchantAccountGroupService.get({ businessId, merchantId, accountNumber })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

// mutations
const mutations = {
  setMerchants (state, merchants) {
    state.merchants = merchants
  },

  setMerchant (state, merchant) {
    state.merchants.push(merchant)
  },

  updateMerchant (state, merchant) {
    state.merchants = state.merchants.map(item =>
      item.merchantId === merchant.merchantId ? Object.assign(item, merchant) : item
    )
  },

  deleteMerchant (state, merchantId) {
    state.merchants = state.merchants.filter(merchant => merchant.merchantId !== merchantId)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
